import script from "./FadeInSection.vue?vue&type=script&setup=true&lang=js"
export * from "./FadeInSection.vue?vue&type=script&setup=true&lang=js"

import "./FadeInSection.vue?vue&type=style&index=0&id=59b5ca44&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59b5ca44"]])

export default __exports__